<div class="modal--generic agent-amend-modal">
  <h1 class="modal__header">Decline Temporary Coverage</h1>
  <h2 class="modal__sub-header">This cannot be undone.</h2>
  <p class="modal__text">Please confirm you'd like to decline temporary coverage and proceed with your application.</p>
  <div class="modal__actions modal__actions--inline">
    <button class="button button--blue button--primary modal__button" (click)="confirm()">Confirm</button>
    <button class="button button--blue button--secondary button--no-border modal__button" (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
